module.exports = __webpack_public_path__ + "img/book1-active.39a72b06.svg";